import React from 'react';
const FormControls = (props) => {
    return <div className="control-column">{props.children}</div>
}
export default FormControls